import { render, staticRenderFns } from "./dynamic-editCommentAlert.vue?vue&type=template&id=2f526989&scoped=true&"
import script from "./dynamic-editCommentAlert.vue?vue&type=script&lang=js&"
export * from "./dynamic-editCommentAlert.vue?vue&type=script&lang=js&"
import style0 from "./dynamic-editCommentAlert.vue?vue&type=style&index=0&id=2f526989&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f526989",
  null
  
)

export default component.exports